import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

class AlertDialog extends PureComponent {
  render() {
    const { isOpen, handleClose, handleAccept, title, body } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        disableRestoreFocus
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleAccept} color="primary" autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default AlertDialog;

AlertDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

AlertDialog.defaultProps = {
  title: '',
  body: '',
};



// WEBPACK FOOTER //
// ./src/components/AlertDialog.js